import { VisaDocumentFlightsModel } from 'api-hooks/visa-document';
import { PlusCircleSVG } from 'common/assets';
import EmptyView from 'components/common/empty-view';
import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import isEmpty from 'lodash/isEmpty';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import VisaDocumentFlightSchedule from './visa-document-flight-schedule';
import { addNewFlightSchedule } from '../../hooks/use-get-default-values';
import { VisaDocumentFormType } from '../visa-document-form-type';

export default function VisaDocumentFlightForm({
  visaDocumentFlights,
}: {
  visaDocumentFlights?: VisaDocumentFlightsModel[];
}) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { control, formState, trigger } =
    useFormContext<VisaDocumentFormType>();
  const name = 'visaDocumentFlights' as const;

  const { fields, append, remove } = useFieldArray({
    control,
    name,
    keyName: '__customId',
  });

  const onAdd = React.useCallback(() => {
    append(addNewFlightSchedule());
    trigger(name);
  }, [append, trigger]);

  const onRemove = React.useCallback((index) => remove(index), [remove]);

  if (visaDocumentFlights?.length === 0) {
    return <EmptyView />;
  }

  return (
    <div>
      {fields.map((field, idx) => {
        const isParentError = !isEmpty(
          formState?.errors?.visaDocumentFlights?.[idx],
        );
        return (
          <React.Fragment key={field.__customId}>
            <VisaDocumentFlightSchedule
              parentIndex={idx}
              onRemove={() => onRemove(idx)}
              fieldLength={fields.length}
              isParentError={isParentError}
            />
            <SeparatorVertical $margin={24}>
              <div style={{ height: 1, width: 4 }} />
            </SeparatorVertical>
          </React.Fragment>
        );
      })}
      {editable && (
        <Button
          startEnhancer={(color, size) => (
            <PlusCircleSVG color={color} size={size} />
          )}
          buttonType="secondary"
          onClick={onAdd}
        >
          {t('common:schedule')}
        </Button>
      )}
    </div>
  );
}
